var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ingredients"}},[_c('h2',[_vm._v("Ingredients ("+_vm._s(_vm.ingredients.length)+"): ")]),_c('ul',_vm._l((_vm.ingredients),function(ingredient){return _c('li',{key:ingredient.id},[_c('IngredientItem',{attrs:{"ingredient":ingredient}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }